var _mask, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1737_1147",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H40C48.8366 0 56 7.16344 56 16V40C56 48.8366 48.8366 56 40 56H16C7.16344 56 0 48.8366 0 40V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H40C48.8366 0 56 7.16344 56 16V40C56 48.8366 48.8366 56 40 56H16C7.16344 56 0 48.8366 0 40V16Z",
    fill: "#00BBA7",
    fillOpacity: 0.09
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0V0.666667H40V0V-0.666667H16V0ZM56 16H55.3333V40H56H56.6667V16H56ZM40 56V55.3333H16V56V56.6667H40V56ZM0 40H0.666667V16H0H-0.666667V40H0ZM16 56V55.3333C7.53163 55.3333 0.666667 48.4684 0.666667 40H0H-0.666667C-0.666667 49.2047 6.79525 56.6667 16 56.6667V56ZM56 40H55.3333C55.3333 48.4684 48.4684 55.3333 40 55.3333V56V56.6667C49.2047 56.6667 56.6667 49.2047 56.6667 40H56ZM40 0V0.666667C48.4684 0.666667 55.3333 7.53163 55.3333 16H56H56.6667C56.6667 6.79526 49.2047 -0.666667 40 -0.666667V0ZM16 0V-0.666667C6.79526 -0.666667 -0.666667 6.79525 -0.666667 16H0H0.666667C0.666667 7.53163 7.53163 0.666667 16 0.666667V0Z",
    fill: "#00BBA7",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_1737_1147)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5833 26.917H20.4167C19.22 26.917 18.25 27.887 18.25 29.0837V36.667C18.25 37.8636 19.22 38.8337 20.4167 38.8337H35.5833C36.78 38.8337 37.75 37.8636 37.75 36.667V29.0837C37.75 27.887 36.78 26.917 35.5833 26.917Z",
    stroke: "#00BBA7",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5833 26.917V22.5837C22.5833 21.1471 23.1539 19.7693 24.1698 18.7535C25.1856 17.7377 26.5633 17.167 27.9999 17.167C29.4365 17.167 30.8143 17.7377 31.8301 18.7535C32.8459 19.7693 33.4166 21.1471 33.4166 22.5837V26.917",
    stroke: "#00BBA7",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.855c57a0642b85388ec34d3e868968ab.svg";
export { ForwardRef as ReactComponent };